// ⚠️⚠️⚠️⚠️ DO NOT EDIT ⚠️⚠️⚠️⚠️
// This file was automatically generated, run pnpm gen:gql to update it
/* eslint-disable */

import type * as Types from '../../../../schema/public';

import { gql } from '@apollo/client';
export type GameDescriptionFragment = { __typename?: 'ContentPage', id: string, name?: string, title?: string, metaDescription?: string, mainBlock?: string };

export const GameDescriptionFragmentDoc = /*#__PURE__*/ gql`
    fragment GameDescriptionFragment on ContentPage {
  id
  name
  title
  metaDescription
  mainBlock
}
    `;